import React from 'react';

const CONTACT_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  'name': 'Disco Duck Events',
  'url': 'https://www.discoduckevents.com',
  'areaServed': 'Kansas City Metropolitan Area',
  'telephone': '+1-913-238-9020',
  'contactPoint': {
    '@type': 'ContactPoint',
    'telephone': '+1-913-238-9020',
    'contactType': 'customer service',
    'url': 'https://www.discoduckevents.com/contact',
    'availableLanguage': 'English'
  },
  'sameAs': [
    'https://www.facebook.com/discoduckevents',
    'https://www.instagram.com/discoduckevents/'
  ]
};

const Footer = () => {
  return (
    <footer className="footer">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(CONTACT_SCHEMA) }}
      />
      <div className="section-container">
        <div className="footer-content">
          <div className="footer-logo">
            <img
              src="/DiscoDuckLogo.png"
              width="600"
              height="750"
              alt="Disco Duck Events logo"
              className="footer-logo-image"
            />
          </div>
          <div className="footer-info">
            <p>&copy; 2026 Disco Duck Events. All Rights Reserved.</p>
            <p>Premium Event Rentals — Kansas City</p>
            <p><a href="tel:+19132389020" className="footer-phone">(913) 238-9020</a></p>
            <div className="footer-social">
              <a href="https://www.instagram.com/discoduckevents/" target="_blank" rel="noopener noreferrer" aria-label="Disco Duck Events on Instagram">Instagram</a>
              <a href="https://www.facebook.com/discoduckevents" target="_blank" rel="noopener noreferrer" aria-label="Disco Duck Events on Facebook">Facebook</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
